module.exports = __webpack_public_path__ + "static/media/separator.cf4dea36.svg";